<template>
  <Loading v-if="loading" />
  <div class="verifiedUser">
    <div v-if="!status?.message && !loading" class="container">
      <form>
        <Input
          type="text"
          :value="resultPickupPin.pickupPin"
          disabled
          :label="$t('youReservationPinCode')"
        />
      </form>
      <qrcode-vue :value="resultPickupPin.pickupPin" :size="250" level="H" />
    </div>
    <div v-if="status?.message" class="verifiedUser__error">
      <div class="error" role="alert">
        {{ $t(status.message) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';
import QrcodeVue from 'qrcode.vue';

@Options({
  name: 'VerifiedUser',
  components: {
    Loading,
    QrcodeVue
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState('account', ['resultPickupPin', 'status'])
  },
  created() {
    this.show();
  },
  methods: {
    ...mapActions('account', ['authorizeUser']),
    async show() {
      this.loading = true;

      const payload = {
        verificationData: window.location.search
      };
      await this.authorizeUser(payload);

      this.loading = false;
    }
  }
})
export default class VerifiedUserComponent extends Vue {}
</script>

<style lang="scss" scoped>
.verifiedUser {
  width: 100%;
  height: 100%;
  padding-top: 40px;
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    form {
      width: 250px;
    }
  }
  .verifiedUser__error {
    .error {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: $sixteenSize;
      line-height: $eighteenSize;
      font-weight: 400;
      color: $messageError;
    }
  }
}
</style>
